/** @format */

import { Component, OnInit } from '@angular/core';
import { Observable, takeUntil, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { Profile, Configuration, blankConfiguration } from 'src/app/models/profile';
import { getProfile, getProfilePicture } from 'src/app/store';
import * as HelperFunctions from 'src/assets/helper-functions/helper-functions';
import { User } from 'src/app/store/application';

@Component({
    selector: 'app-profile-page',
    templateUrl: './profile-page.component.html',
    styleUrls: ['./profile-page.component.scss'],
    standalone: false
})
export class ProfilePageComponent implements OnInit {
	private ngUnsubscribe: Subject<void> = new Subject();
	profile$: Observable<Profile>;
	profile: Profile = {
		user: {
			firstName: '',
			lastName: '',
		} as unknown as User,
		configuration: [],
		manage: [],
		managedGoneFromDNV: [],
		delegated: [],
		delegatedFrom: [],
		delegatedTo: [],
		scheduledActings: [],
		allUsers: [],
		timekeeperDelegated: [],
		timekeeperManagedUsers: [],
	};

	currentConfiguration: Configuration = blankConfiguration;
	profilePicture$: Observable<string | Blob | null>;
	base64ProfilePhoto: any;
	infoDropdownOpen: boolean = false;
	week1WorkHours: number[] = [];
	week2WorkHours: number[] = [];
	week1TotalHours: number = 0;
	week2TotalHours: number = 0;

	constructor(private store: Store<{}>) {
		this.profile$ = this.store.select(getProfile);
		// profileService.profilePicture$.subscribe(profilePicture => {
		//   this.profilePicture = profilePicture
		//   if (this.profilePicture) {
		//     let reader = new FileReader();
		//     reader.onloadend = () => { this.base64ProfilePhoto = reader.result; }
		//     reader.readAsDataURL(this.profilePicture);
		//   }
		// });
		this.profilePicture$ = this.store.select(getProfilePicture);
	}

	ngOnInit(): void {
		this.profile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profile) => {
			this.profile = profile;
			this.currentConfiguration = HelperFunctions.getCurrentConfiguration(profile.configuration) || blankConfiguration;
		});
		this.profilePicture$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profilePicture: any) => {
			if (profilePicture) {
				if ('string' === typeof profilePicture) {
					this.base64ProfilePhoto = profilePicture;
				} else {
					let reader = new FileReader();
					reader.onloadend = () => {
						this.base64ProfilePhoto = reader.result;
					};
					reader.readAsDataURL(profilePicture);
				}
			}
		});

		this.calculateWeeklyTotals();
	}

	calculateWeeklyTotals() {
		// week 1
		for (let i = 1; i <= 7; i++) {
			// configuration uses 1-based indexing for days
			if (i == this.currentConfiguration.cdoDay || !HelperFunctions.isIndexWorkDay(i - 1)) {
				this.week1WorkHours.push(Number(0.0));
			} else if (i == this.currentConfiguration.modifiedDurationDay) {
				this.week1WorkHours.push(this.currentConfiguration.durationOfModifiedDay);
			} else {
				this.week1WorkHours.push(this.currentConfiguration.durationOfRegularDay);
			}
		}
		this.week1TotalHours = this.week1WorkHours.reduce((total, curr) => total + curr);

		// week 2
		for (let i = 8; i <= 14; i++) {
			if (i == this.currentConfiguration.cdoDay || !HelperFunctions.isIndexWorkDay(i - 1)) {
				this.week2WorkHours.push(0.0);
			} else if (i == this.currentConfiguration.modifiedDurationDay) {
				this.week2WorkHours.push(this.currentConfiguration.durationOfModifiedDay);
			} else {
				this.week2WorkHours.push(this.currentConfiguration.durationOfRegularDay);
			}
		}
		this.week2TotalHours = this.week2WorkHours.reduce((total, curr) => total + curr);
	}
}
